import { render, staticRenderFns } from "./AdminCoupons.vue?vue&type=template&id=17006986&scoped=true"
import script from "./AdminCoupons.vue?vue&type=script&lang=js"
export * from "./AdminCoupons.vue?vue&type=script&lang=js"
import style0 from "./AdminCoupons.vue?vue&type=style&index=0&id=17006986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17006986",
  null
  
)

export default component.exports